import { combineReducers } from "@reduxjs/toolkit";
import scoreCategories from "./score-categories-slice";

const assessmentsAndReportsReducer = combineReducers({
    scoreCategories: scoreCategories.reducer
});

export default assessmentsAndReportsReducer;